// Segmented quiz / «Норм чи Стрьом» switch used wherever content or a lineup
// is created. Reuses the shout-mode toggle look.
import type { GameKind } from '../shared/protocol';
import { useT } from '../i18n';

/** Normalises an optional persisted kind (absent == quiz). */
export const kindOf = (k?: GameKind | string): GameKind => (k === 'normcringe' ? 'normcringe' : 'quiz');

export function KindToggle({ value, onChange, disabled }: { value: GameKind; onChange: (k: GameKind) => void; disabled?: boolean }) {
  const t = useT();
  return (
    <span className="modetoggle" role="group" aria-label={t('kind.label')}>
      <button type="button" className={value === 'quiz' ? 'toggle on' : 'toggle'} disabled={disabled} onClick={() => onChange('quiz')}>
        {t('kind.quiz')}
      </button>
      <button type="button" className={value === 'normcringe' ? 'toggle on' : 'toggle'} disabled={disabled} onClick={() => onChange('normcringe')}>
        {t('kind.normcringe')}
      </button>
    </span>
  );
}
